export interface CommissionNotePrintOptions {
  language?: string | null
  summary: boolean
  nb_summary: number
  detailed: boolean
  nb_detailed: number
  recto_verso: boolean
  page_numbering: boolean
  footer_id: number | string | null
  /** id of a header of the agency, or 'none' for pre-printed paper */
  header: number | string | null
}

export const NO_HEADER = 'none'

export const defaultPrintOptions = (): CommissionNotePrintOptions => ({
  language: null,
  summary: false,
  nb_summary: 1,
  detailed: true,
  nb_detailed: 1,
  recto_verso: false,
  page_numbering: true,
  footer_id: null,
  header: null
})

/**
 * The options saved in the settings of the agency (`COMNOTE`) over the
 * defaults, and the language of the note.
 */
export const printOptionsFor = (
  agencySettings: Partial<CommissionNotePrintOptions> | null | undefined,
  language?: string | null
): CommissionNotePrintOptions => ({
  ...defaultPrintOptions(),
  ...agencySettings,
  language: language ?? agencySettings?.language ?? null
})

const copies = (value: unknown) =>
  Math.min(10, Math.max(1, Math.trunc(Number(value)) || 1))

/**
 * The query of the PDF and the `print_options` of the e-mail: flags as 1/0
 * (the API does not read true/false), copies between 1 and 10, nothing sent
 * for an empty choice (the API then falls back to the agency settings).
 */
export const printQuery = (options: Partial<CommissionNotePrintOptions>) => {
  const query: Record<string, string | number> = {}
  const flag = (key: keyof CommissionNotePrintOptions) => {
    if (options[key] !== undefined && options[key] !== null) {
      query[key] = options[key] ? 1 : 0
    }
  }

  flag('summary')
  flag('detailed')
  flag('recto_verso')
  flag('page_numbering')
  if (options.summary) query.nb_summary = copies(options.nb_summary)
  if (options.detailed) query.nb_detailed = copies(options.nb_detailed)
  if (options.footer_id) query.footer_id = options.footer_id
  if (options.header) query.header = options.header
  if (options.language) query.language = options.language

  return query
}
